import React, { useState, useEffect } from "react";
import i18n from "./i18n";
import { withTranslation, useTranslation } from "react-i18next";
import { StaticImage } from "gatsby-plugin-image";
import NavigationHelper from "../helpers/navigation";
import SocialData from "../conf/social.json";
import { Link as GatsbyLink } from "gatsby";
import Link from "./Link";

export default function Footer() {
  const [activeLanguage, setActiveLanguage] = useState(i18n.language);
  const { t } = useTranslation(["main", "forms"]);
  const LocalizedLink = withTranslation("main")(GatsbyLink);
  const ExternalLink = withTranslation("main")(Link);

  // Créer un hook personnalisé pour générer les liens
  const useGenerateMenuLinks = (language) => {
    return {
      home: NavigationHelper.useGeneratePageURL(language, "home"),
      services: NavigationHelper.useGeneratePageURL(language, "services"),
      vision: NavigationHelper.useGeneratePageURL(language, "vision"),
      publications: NavigationHelper.useGeneratePageURL(
        language,
        "publications"
      ),
      testimonials: NavigationHelper.useGeneratePageURL(
        language,
        "testimonials"
      ),
      join: NavigationHelper.useGeneratePageURL(language, "join"),
      blog: NavigationHelper.useGeneratePageURL(language, "blog"),
      legal: NavigationHelper.useGeneratePageURL(language, "legal"),
      privacy: NavigationHelper.useGeneratePageURL(language, "privacy"),
      terms: NavigationHelper.useGeneratePageURL(language, "terms"),
    };
  };

  // Utiliser le hook pour générer les liens dynamiquement à chaque rendu
  const menuLinks = useGenerateMenuLinks(activeLanguage);

  return (
    <>
      <footer className="site-footer">
        <div className="container">
          <div className="mobile-footer mobile_view">
            <div className="row">
              <div className="col-12 text-center">
                <div className="footer-logo">
                  <StaticImage
                    src="../images/Logo-white.png"
                    alt="A1 Cloud Technologies: logo"
                  />
                </div>
              </div>
              <div className="col-12 footer-menu">
                <div className="footer-text">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <h5 className="mb-0">
                          <LocalizedLink
                            to={menuLinks.services || "#"}
                            title={t(
                              "main:home_services-list_see-all-services-seo-title_txt"
                            )}
                          >
                            <button className="btn btn-link">
                              <h4>
                                {t("main:global_footer_services_menu-item")}
                              </h4>
                            </button>
                          </LocalizedLink>
                        </h5>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="mb-0">
                          <LocalizedLink
                            to={menuLinks.vision || "#"}
                            title={t("main:home_see-vision-seo-title_txt")}
                          >
                            <button className="btn btn-link">
                              <h4>
                                {t("main:global_footer_vision_menu-item")}
                              </h4>
                            </button>
                          </LocalizedLink>
                        </h5>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingThree">
                        <h5 className="mb-0">
                          <LocalizedLink
                            to={menuLinks.join || "#"}
                            title={t("main:global_footer_joinus-link-seo-txt")}
                          >
                            <button className="btn btn-link">
                              <h4>
                                {t("main:global_footer_joinus_menu-item")}
                              </h4>
                            </button>
                          </LocalizedLink>
                        </h5>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingfour">
                        <h5 className="mb-0">
                          <LocalizedLink
                            to={`${menuLinks.home || "#"}#contact-form`}
                            title={t(
                              "main:global_footer_contactus-link-seo-title-txt"
                            )}
                          >
                            <button className="btn btn-link">
                              <h4>
                                {t("main:global_footer_contact_menu-item")}
                              </h4>
                            </button>
                          </LocalizedLink>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Footer */}
          <div className="destop-footer desktop_view">
            <div className="row ">
              <div className="col">
                <div className="footer-logo">
                  <StaticImage
                    src="../images/Logo-white.png"
                    alt={t("home_main_our-services_title")}
                    quality={70}
                  />
                  <div className="main-addresh">
                    <p>
                      Bureau 3 <br />9 rue de Condé <br />
                      33000 Bordeaux <br />
                      FRANCE
                    </p>
                    <p>
                      <b>{t("main:global_footer_phone_number_txt")}</b>
                    </p>
                    <p>
                      SAS au capital de 15 000€ <br />
                      N°RCS&nbsp;Bordeaux : 850&nbsp;099 094
                    </p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="footer-text">
                  <h4>{t("main:global_footer_services_menu-item")}</h4>
                  <ul>
                    <li>
                      {t("main:global_footer_services-txt_p1")}&nbsp;
                      <LocalizedLink
                        to={menuLinks.services || "#"}
                        title={t(
                          "main:home_services-list_see-all-services-seo-title_txt"
                        )}
                      >
                        {t("main:global_footer_services-txt_p2")}
                      </LocalizedLink>
                      &nbsp;{t("main:global_footer_services-txt_p3")}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-text">
                  <h4>{t("main:global_footer_vision_menu-item")}</h4>
                  <ul>
                    <li>
                      {t("main:global_footer_vision-txt_p1")}&nbsp;
                      <LocalizedLink
                        to={menuLinks.vision || "#"}
                        title={t("main:home_see-vision-seo-title_txt")}
                      >
                        {t("main:global_footer_vision-txt_p2")}
                      </LocalizedLink>
                      .
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-text">
                  <h4>{t("main:global_footer_joinus_menu-item")}</h4>
                  <ul>
                    <li>
                      {t("main:global_footer_joinus-txt_p1")} <br />
                      <LocalizedLink
                        to={menuLinks.join || "#"}
                        title={t("main:global_footer_joinus-link-seo-txt")}
                      >
                        {t("main:global_footer_joinus-txt_p2")}
                      </LocalizedLink>
                      &nbsp;{t("main:global_footer_joinus-txt_p3")}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-text">
                  <h4>{t("main:global_footer_contact_menu-item")}</h4>
                  <ul>
                    <li>
                      {t("main:global_footer_contactus-txt_p1")}
                      <br />
                      {t("main:global_footer_contactus-txt_p2")}
                      <br />
                      <LocalizedLink
                        to={`${menuLinks.home || "#"}#contact-form`}
                        title={t(
                          "main:global_footer_contactus-link-seo-title-txt"
                        )}
                      >
                        {t("main:global_footer_contactus-txt_p3")}
                      </LocalizedLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-text">
                  <h4>{t("main:global_footer_followus_menu-item")}</h4>
                  <ul className="footer-icon">
                    <li>
                      <ExternalLink
                        target="_blank"
                        link={SocialData.urls.linkedin}
                        title={t("main:global_seo_followus_linkedin_txt")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                        >
                          <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
                        </svg>
                      </ExternalLink>
                    </li>
                    {/* <li>
                      <ExternalLink
                        target="_blank"
                        link={SocialData.urls.twitter}
                        title={t("main:global_seo_followus_twitter_txt")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                        >
                          <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z" />
                        </svg>
                      </ExternalLink>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="copyright text-center">
              <p>
                ©2022 A1 Cloud Technologies.&nbsp;
                <LocalizedLink
                  to={menuLinks.legal || "#"}
                  title={t(
                    "main:global_footer_legal-notice_link-seo-title-txt"
                  )}
                >
                  {t("main:global_footer_legal-notice_link")}.
                </LocalizedLink>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
